import React from "react";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import EstimateProjectForm from "../../WebDevelopmentPage/EstimateProjectForm";
import GdImagePlaceholder from "./GdImagePlaceholder";

const highlights = [
  {
    title: "Customer App",
    description: "Browse stores, search products, checkout, track orders, and manage wishlists.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="7" y="2" width="10" height="20" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M11 18h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Vendor Panel",
    description: "Manage products, branches, staff, orders, offers, and delivery scheduling.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M3 9l2-5h14l2 5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M4 9v10h16V9" stroke="currentColor" strokeWidth="1.5" />
        <path d="M9 19V12h6v7" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "Admin Dashboard",
    description: "Control vendors, categories, commissions, subscriptions, and business reports.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="4" width="18" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
        <rect x="3" y="14" width="18" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "Delivery Boy App",
    description: "GPS navigation, order acceptance, status updates, and customer communication.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
        <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
];

const GdIntroSection: React.FC = () => {
  return (
    <section className="wdev-intro gd-intro" aria-labelledby="gd-intro-title">
      <div className="container">
        <AnimatedSection className="gd-intro__visual-wrap">
          <GdImagePlaceholder
            variant="devices"
            label="Grocery App Ecosystem"
            hint="Admin dashboard · Customer app · Delivery app"
            className="gd-intro__visual"
          />
        </AnimatedSection>

        <div className="wdev-intro__grid">
          <AnimatedSection className="wdev-intro__content">
            <span className="wdev-label wdev-label--purple">Grocery Delivery Platform</span>
            <h2 id="gd-intro-title" className="wdev-intro__title">
              Grocery App Development Company
            </h2>

            <p className="wdev-intro__text">
              We build on-demand grocery delivery apps similar to Instacart or Amazon Fresh — tailored
              for local grocery stores or multi-vendor aggregators. Our solutions connect customers,
              vendors, delivery personnel, and administrators in one seamless ecosystem.
            </p>
            <p className="wdev-intro__text">
              WebTech creates grocery delivery mobile apps suitable for single grocery shop owners,
              multi-vendor grocery marketplaces, and grocery chain stores — matching your unique
              requests and objectives with our best-fit development solutions.
            </p>

            <div className="wdev-intro__highlights">
              {highlights.map((item) => (
                <div className="wdev-intro__highlight" key={item.title}>
                  <div className="wdev-intro__highlight-icon">{item.icon}</div>
                  <div>
                    <h3 className="wdev-intro__highlight-title">{item.title}</h3>
                    <p className="wdev-intro__highlight-desc">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </AnimatedSection>

          <AnimatedSection className="wdev-intro__form-wrap" delay={0.15}>
            <EstimateProjectForm />
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default GdIntroSection;
